import { useCallback, useState } from 'react';
import { ProyectosGet, ProyectoGet, ClientesGet, ProyectosAdd, ProyectosUpdate, ProyectosDelete } from '../service/proyectos';

export default function useUsers() {
    // Estado de carga del listado: los servicios Add/Update/Delete ya movían
    // State.loading, pero el GET no, y las tablas no tenían cómo saber que
    // todavía estaban esperando datos.
    const [cargando, setCargando] = useState(false);

    const [Proyectos, setProyectos] = useState([]);
    const [Proyecto, setProyecto] = useState([]);
    const [Clientes, setClientes] = useState([]);
    const [State, setState] = useState({ loading: false, error: false, message: '', success: false });

    const ProyectosGetService = useCallback((token) => {
        setCargando(true);
        ProyectosGet(token).then(response => {
            setProyectos(response ?? []);
        }).finally(() => setCargando(false))
    }, []);

    const ProyectoGetService = useCallback((id, token) => {
        ProyectoGet(id, token).then(response => {
            setProyecto(response ?? []);
        })
    }, []);

    const ClientesGetService = useCallback((token) => {
        ClientesGet(token).then(response => {
            setClientes(response)
        })
    }, []);

    /*
     * Agregar Variable
     */
    const ProyectosAddService = useCallback((
        data, token
    ) => {
        setState({
            loading: true,
            error: false,
            message: '',
            success: false
        });
        ProyectosAdd(
            data, token
        ).then(response => {
            let errores = response.errors;
            if (errores != undefined) {
                let primerError = Object.values(errores)[0];
                setState({
                    loading: false,
                    error: true,
                    message: primerError ? primerError[0] : 'Datos inválidos',
                    success: false
                })
            } else {
                if (response.guardado === true) {
                    setState({
                        loading: false,
                        error: false,
                        message: 'Proyecto registrado con exito',
                        success: true
                    })
                } else {
                    setState({
                        loading: false,
                        error: true,
                        message: 'Error al registrar proyecto',
                        success: false
                    })
                }
            }
        }).catch(() => {
            setState({
                loading: false,
                error: true,
                message: 'No se pudo conectar con el servidor',
                success: false
            })
        })
    }, [])

    /*
     * Actualizar Variable
     */
    const ProyectosUpdateService = useCallback((
        data, token
    ) => {
        setState({
            loading: true,
            error: false,
            message: '',
            success: false
        });
        ProyectosUpdate(
            data, token
        ).then(response => {
            let errores = response.errors;
            if (errores != undefined) {
                let primerError = Object.values(errores)[0];
                setState({
                    loading: false,
                    error: true,
                    message: primerError ? primerError[0] : 'Datos inválidos',
                    success: false
                })
            } else {
                if (response.guardado === true) {
                    setState({
                        loading: false,
                        error: false,
                        message: 'Proyecto actualizado con exito',
                        success: true
                    })
                } else {
                    setState({
                        loading: false,
                        error: true,
                        message: 'Error al actualizar proyecto',
                        success: false
                    })
                }
            }
        }).catch(() => {
            setState({
                loading: false,
                error: true,
                message: 'No se pudo conectar con el servidor',
                success: false
            })
        })
    }, [])
    /*
     * Eliminar Variable
     */
    const ProyectosDeleteService = useCallback((
        data, token
    ) => {
        setState({
            loading: true,
            error: false,
            message: '',
            success: false
        });
        ProyectosDelete(
            data, token
        ).then(response => {
            if (response.guardado === true) {
                setState({
                    loading: false,
                    error: false,
                    message: 'Proyecto eliminado con exito',
                    success: true
                })
            } else {
                setState({
                    loading: false,
                    error: true,
                    message: 'Error al eliminar proyecto',
                    success: false
                })
            }
        }).catch(() => {
            setState({
                loading: false,
                error: true,
                message: 'No se pudo conectar con el servidor',
                success: false
            })
        })
    }, [])

    return {
        loading: State.loading || cargando,
        error: State.error,
        message: State.message,
        success: State.success,
        Proyectos,
        Proyecto,
        Clientes,
        ProyectosGetService,
        ProyectoGetService,
        ClientesGetService,
        ProyectosAddService,
        ProyectosUpdateService,
        ProyectosDeleteService
    }
}